// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../k8-opt-exec/bin/redo/shopify/extension/webpack.bin.runfiles/rules_javascript++yarn+redo_npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../k8-opt-exec/bin/redo/shopify/extension/webpack.bin.runfiles/rules_javascript++yarn+redo_npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._w-0 {\n  z-index: 2147483006 !important; /* 1 higher than RedoDropdown */\n}\n\n._w-1 {\n  font-size: var(--size-body-xs);\n  line-height: 18px;\n  color: var(--redo-colors-text-text-tertiary);\n}\n\n._w-2 {\n  text-align: left;\n}\n", ""]);
// Exports
export var popper = "_w-0";
export var subtitle = "_w-1";
export var leftAlign = "_w-2";
export default ___CSS_LOADER_EXPORT___;
